// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"19":"64497684","238":"4bef18df","851":"efbfde18","988":"64497684"}[chunkId] + ".chunk.css";
};